// import { storeStructure } from '../store/reducers';
// import {
//   removeComposeExperienceUrls,
//   createComposeExperienceUrls,
//   updateComposeExperienceUrls,
//   reloadComposeExperienceUrls,
//   getDraftId,
// } from '../store/actions/composeExperienceUrlsActions';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedVodOutputs from './viewRelatedVodOutputs';

export default {
  attributeName: 'composeExperienceUrls',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  emptyMessage: "You don't have any Composed Experience. Add one by clicking on the +new button.",
  fields: [
    {
      attributeName: 'url',
      label: 'Url',
      type: FormInputTypes.TEXT_OR_RELATIONSHIP,
      helpText: 'The urls associated to the composed experience',
      configFile: viewRelatedVodOutputs,
      default: '',
      canEdit: false,
      canCreate: false,
      popupSize:'xl',
      rowKeys: {
        mainKey: 'url',
        foreignKey: 'vodOutputId',
        foreignKeyName: 'vodOutput',
        valueToShow: 'outputFile',
      },
      hasTooltip: true,
      class:'col-sm-8',
      exactWidth: '40%'
    },
    {
      attributeName: 'video_type',
      label: 'Video Type',
      default: 'Autodetect',
      type: FormInputTypes.SELECT,
      helpText: 'Choose one type of content.',
      options: [
        { name: '(Unknown)', value: '-1' },
        { name: '(Autodetect)', value: 'Autodetect' },
        { name: 'Single view', value: 'Single-View' },
        { name: 'Multi view', value: 'Multi-View' },
        { name: 'Immersive', value: 'Immersive' },
        { name: 'Immersive + Multi-View', value: 'Immersive-Multi-View' },
      ],
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'duration',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Duration',
      placeholder: 'Video duration...',
      helpText: 'Duration of the video in the format mm:ss.',
      canEdit: true,
      canCreate: true,
      exactWidth: '12%'
    },
    {
      attributeName: 'eventDate',
      type: FormInputTypes.DATE_PICKER_PARTIAL,
      label: 'Event Date',
      helpText: 'Event date of the video. The expected format is MM/DD/YYYY.',
      canEdit: true,
      canCreate: true,
    }
  ],
};
